import { Component, OnInit, Input } from '@angular/core';
import { TreeControlNode } from 'src/app/shared/model/tree-control-node';
import { StopPile } from 'src/app/vehicles/model/stop-pile';

@Component({
  selector: 'app-bus-stop-tree-item',
  templateUrl: './bus-stop-tree-item.component.html',
  styleUrls: ['./bus-stop-tree-item.component.scss']
})
export class BusStopTreeItemComponent implements OnInit {

  @Input()
  node: TreeControlNode<StopPile>;

  constructor() { }

  ngOnInit(): void { }

}
